import apiClient from './api';

export interface ReservationRequest {
  fullName: string;
  phoneNumber: string;
  bookingDateTime: string; // ISO string
  totalSeats: number;
  occassion: string;
  timeZone?: string;
  locationId?: number;
}

export interface ReservationResponse {
  success: boolean;
  message?: string;
  reservation?: {
    id: number;
    fullName: string;
    phoneNumber: string;
    bookingDateTime: string;
    totalSeats: number;
    occassion: string;
  };
  error?: string;
}

class ReservationService {
  async createReservation(appName: string, data: ReservationRequest): Promise<ReservationResponse> {
    const response = await apiClient.post(`/api/restaurants/${appName}/reserve-table`, data);
    return response.data;
  }
}

export default new ReservationService();

